export function $(selector) {
	return document.querySelector(selector);
}